export default __webpack_public_path__ + "static/tab2Img-656b205c2b97b0160a20b5e0a46d35c1.png";